import { Menu } from "lucide-react";

import { Breadcrumbs } from "@/app/layouts/dashboard/Breadcrumbs";
import { UserMenu } from "@/app/layouts/dashboard/UserMenu";
import { useSidebar } from "@/app/layouts/dashboard/sidebar-context-core";
import { Button } from "@/shared/components/ui/button";
import { Separator } from "@/shared/components/ui/separator";

/**
 * Navbar superior minimal y editorial. Composición:
 *   - Mobile: hamburger · divisor · breadcrumbs · UserMenu
 *   - Desktop: breadcrumbs · UserMenu
 *
 * Altura 64px — hace par con el header del sidebar.
 *
 * Decisión intencional: no incluimos bell ni search placeholder. Agregar
 * UI que no tiene datos reales atrás ("Notificaciones" con dot falso,
 * "⌘K" sin command palette) solo crea afordance muerta. Cuando existan
 * los endpoints, se agregan acá con la data real.
 */
export function AppNavbar() {
  const { openMobile } = useSidebar();

  return (
    <header className="sticky top-0 z-30 flex h-16 shrink-0 items-center gap-3 border-b border-border/60 bg-card/85 px-4 backdrop-blur-md lg:px-8">
      {/* Hamburger — solo en <lg */}
      <Button
        variant="ghost"
        size="icon"
        className="shrink-0 lg:hidden"
        onClick={openMobile}
        aria-label="Abrir menú"
      >
        <Menu className="h-5 w-5" />
      </Button>
      <Separator orientation="vertical" className="h-5 lg:hidden" />

      {/* Breadcrumbs — absorbe el espacio sobrante */}
      <div className="min-w-0 flex-1">
        <Breadcrumbs />
      </div>

      {/* User */}
      <UserMenu />
    </header>
  );
}
